// const axios = require('axios');
import axios from 'axios';

// async function makeGetRequestToUrl(url, params = {}, headers = {}, timeout = 15000) {

//     const defaultHeaders = {
//         ...headers,
//         'Connection': 'keep-alive',
//     };
   
//     const maxRetries = 3;
//     let retries = 0;
   
//     while (retries <= maxRetries) {
//         try {
//             const response = await axios({
//                 method: 'GET',
//                 url,
//                 params,
//                 headers: defaultHeaders,
//                 timeout,
//                 httpVersion: '1.1', // Force HTTP/1.1
//                 maxRedirects: 5,
//             });
//             return response.data;
//         } catch (error) {
//             retries++;
//             console.log(`Request failed, attempt ${retries} of ${maxRetries}`);
//             console.log(`Request failed, attempt ${retries} of ${maxRetries}`);

//             // If we've reached max retries, handle the error and throw
//             if (retries > maxRetries) {
//                 handleHttpError(error, url);
//                 throw error;
//             }
//             // Wait before retrying (exponential backoff)
//             await new Promise(resolve => setTimeout(resolve, 1000 * Math.pow(2, retries - 1)));
//         }
//     }
// }

// async function makeGetRequestToUrl(url, params = {}, headers = { 'Content-Type': 'application/json' }, timeout = 5000) {
//     // Build query string from params
//     const queryString = new URLSearchParams(params).toString();
//     const finalUrl = queryString ? `${url}?${queryString}` : url;

//     // Set up timeout using AbortController
//     const controller = new AbortController();
//     const timeoutId = setTimeout(() => controller.abort(), timeout);

//     try {
//         const response = await fetch(finalUrl, {
//             method: 'GET',
//             headers: headers,
//             signal: controller.signal
//         });

//         clearTimeout(timeoutId); // Clear timeout if successful

//         if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();
//         return data;
//     } catch (error) {
//         handleHttpError(error, url);
//         throw error;
//     }
// }


async function makeGetRequestToUrl(url, params, headers, timeout) {
    // Set defaults inside the function
    headers = headers || { 'Content-Type': 'application/json' };
    timeout = timeout || 15000;

    try {
        const response = await axios({
            method: 'GET',
            url: url,
            params: params,
            headers: headers,  // Use provided headers or default to JSON
            timeout: timeout   // Default timeout set to 5 seconds
        });
        return response.data;  // Return the data from the response
    } catch (error) {
        handleHttpError(error, url);
        throw error;  // Re-throw the error for the calling code to handle
    }
}


async function makePostRequestToUrl(url, data, headers, timeout) {
    // Set defaults inside the function
    data = data || {};
    headers = headers || { 'Content-Type': 'application/json' };
    timeout = timeout || 15000;

    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: data,        // Use provided data or default to empty object
            headers: headers,  // Use provided headers or default to JSON
            timeout: timeout   // Default timeout set to 5 seconds
        });

        return response.data;  // Return the data from the response
    } catch (error) {
        handleHttpError(error, url);
        throw error;  // Re-throw the error for the calling code to handle
    }
}

// Helper function to handle errors for HTTP requests
function handleHttpError(error, url) {
    console.error(`Error calling endpoint at ${url}: ${error.message}`);

    if (error.response) {
        // If the server responded with a status code out of the 2xx range
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
    } else if (error.request) {
        // If the request was made but no response was received
        console.error('No response received:', error.request);
    } else {
        // Something else happened during the request setup
        console.error('Error setting up the request:', error.message);
    }
}

// Parse CSV line considering quoted fields (which may contain commas)
const parseCSVLine = (line) => {
    const result = [];
    let inQuotes = false;
    let currentValue = '';
    let i = 0;
    
    while (i < line.length) {
        const char = line[i];
        
        if (char === '"') {
            // Handle quotes
            if (i + 1 < line.length && line[i + 1] === '"') {
                // Double quotes inside quoted field - add a single quote
                currentValue += '"';
                i += 2;
            } else {
                // Toggle quote mode
                inQuotes = !inQuotes;
                i++;
            }
        } else if (char === ',' && !inQuotes) {
            // End of field
            result.push(currentValue.trim());
            currentValue = '';
            i++;
        } else {
            // Regular character
            currentValue += char;
            i++;
        }
    }
    
    // Add the last field
    result.push(currentValue.trim());
    return result;
};

// Enhanced CSV import with case-insensitive column handling and support for quoted fields
const handleImportCSVWithCaseInsensitive = (file, onSuccess, onError, requiredColumns = [], alternativeColumns = {}) => {
    if (!file) {
        console.error('No file provided');
        if (onError) onError('No file selected');
        return;
    }

    // Check if the file is a valid format
    console.log('File type:', file.type, 'File name:', file.name);
    const validTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/xlsx', 'application/x-iwork-numbers-sffnumbers'];
    const validExtensions = ['.csv', '.xlsx', '.numbers'];
    
    const hasValidType = validTypes.includes(file.type);
    const hasValidExtension = validExtensions.some(ext => file.name.toLowerCase().endsWith(ext));
    
    if (!hasValidType && !hasValidExtension) {
        console.error('Invalid file type:', file.type);
        if (onError) onError('Please select a CSV, XLSX or Numbers file');
        return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
        try {
            const content = e.target.result;
            // Split by newlines but respect different OS line endings
            const lines = content.split(/\r?\n/);
            if (lines.length === 0) {
                onError('CSV file is empty');
                return;
            }
            
            // Parse headers properly handling quoted fields
            const rawHeaders = parseCSVLine(lines[0]);
            const headerMap = {};
            
            // Create a case-insensitive mapping of headers
            rawHeaders.forEach((header, index) => {
                const cleanHeader = header.trim();
                headerMap[cleanHeader.toLowerCase()] = { 
                    originalName: cleanHeader,
                    index: index 
                };
            });
            
            console.log('Header mapping:', headerMap);
            
            // If all required columns exist in a case-insensitive way, transform the CSV
            const missingCols = [];
            requiredColumns.forEach(reqCol => {
                const found = headerMap[reqCol.toLowerCase()] || 
                    Object.keys(headerMap).find(h => 
                        alternativeColumns[reqCol]?.some(alt => 
                            alt.toLowerCase() === h.toLowerCase()
                        )
                    );
                
                if (!found) missingCols.push(reqCol);
            });
            
            if (missingCols.length === 0) {
                // All required columns found - parse data correctly
                const parsedData = [];
                for (let i = 1; i < lines.length; i++) {
                    if (!lines[i].trim()) continue;
                    const rowValues = parseCSVLine(lines[i]);
                    const dataRow = {};
                    
                    // Map values to the correct fields
                    requiredColumns.forEach(col => {
                        let value = '';
                        const directMatch = headerMap[col.toLowerCase()];
                        if (directMatch && directMatch.index < rowValues.length) {
                            value = rowValues[directMatch.index];
                        } else {
                            for (const alt of (alternativeColumns[col] || [])) {
                                const altMatch = headerMap[alt.toLowerCase()];
                                if (altMatch && altMatch.index < rowValues.length) {
                                    value = rowValues[altMatch.index];
                                    break;
                                }
                            }
                        }
                        dataRow[col] = value;
                    });
                    parsedData.push(dataRow);
                }
                onSuccess(parsedData, requiredColumns);
            } else {
                onError({
                    message: `CSV is missing required columns: ${missingCols.join(', ')}`,
                    missingColumns: missingCols,
                    templateCSV: `${requiredColumns.join(',')}\n${
                        requiredColumns.map(col => `[${col}]`).join(',')
                    }`
                });
            }
            
        } catch (error) {
            console.error('Error pre-processing CSV:', error);
            onError({ message: 'Error parsing CSV file' });
        }
    };
    reader.onerror = () => {
        console.error('Error reading file for pre-processing');
        onError('Error reading file');
    };
    reader.readAsText(file);
};

// Process bulk data import and send to API
const processBulkImport = async (data, token, url, entityType, mapFunction) => {
    if (!data || data.length === 0) {
        console.warn(`No valid ${entityType} data to import`);
        return { success: false, count: 0, message: `No valid ${entityType} data to import` };
    }
    
    try {
        // Create an array of entity objects using the provided mapping function
        const mappedData = data.filter(item => mapFunction(item) !== null).map(mapFunction);
        
        // If no valid entities found
        if (mappedData.length === 0) {
            console.warn(`No valid ${entityType} found in CSV`);
            return { success: false, count: 0, message: `No valid ${entityType} found in CSV` };
        }
        
        console.log(`Sending bulk ${entityType}:`, mappedData);
        
        // Create the payload with the token and mapped data
        const payload = {
            token: token,
            [entityType]: mappedData // Use the entityType as the key (e.g., 'locations' or 'chassis')
        };
        
        // Make a single API call with all entities
        const response = await makePostRequestToUrl(url, payload);
        
        if (response.flag === 200) {
            console.log(`Successfully added ${mappedData.length} ${entityType}`);
            return { 
                success: true, 
                count: mappedData.length, 
                message: `Successfully imported ${mappedData.length} ${entityType}` 
            };
        } else {
            console.warn(`Error adding ${entityType}:`, response);
            return { 
                success: false, 
                count: 0, 
                message: `Error importing ${entityType}: ${response.message || 'Unknown error'}` 
            };
        }
        
    } catch (error) {
        console.error(`Error processing ${entityType}:`, error);
        return { 
            success: false, 
            count: 0, 
            message: `Error processing ${entityType}: ${error.message || 'Unknown error'}` 
        };
    }
};

// Legacy importCSV function for backward compatibility
const importCSV = (file, onSuccess, onError, requiredColumns = [], alternativeColumns = {}) => {
    console.log('importCSV called with file:', file);
    console.log('Required columns:', requiredColumns);
    console.log('Alternative columns:', alternativeColumns);
    
    // Forward to enhanced implementation
    handleImportCSVWithCaseInsensitive(file, onSuccess, onError, requiredColumns, alternativeColumns);
};

export {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
};